import { Platform, type TextStyle } from 'react-native';

export const IOS_BOLD_TEXT_WEIGHT_REDUCTION = 100;
export const MIN_ADJUSTED_FONT_WEIGHT = 200;

export function parseFontWeightToNumber(weight: TextStyle['fontWeight']): number | undefined {
  if (weight == null) return undefined;
  if (typeof weight === 'number') return weight;
  if (weight === 'normal') return 400;
  if (weight === 'bold') return 700;
  const parsed = Number.parseInt(String(weight), 10);
  return Number.isFinite(parsed) ? parsed : undefined;
}

/**
 * When iOS “Bold Text” accessibility is on, the system already emboldens text.
 * Lower the declared `fontWeight` by 100 to avoid looking too heavy.
 */
export function getIosBoldTextAdjustedFontWeightStyle(
  fontWeight: TextStyle['fontWeight'] | undefined,
): TextStyle | undefined {
  if (Platform.OS !== 'ios' || fontWeight == null) {
    return undefined;
  }
  const current = parseFontWeightToNumber(fontWeight);
  if (current == null) return undefined;
  const next = Math.max(MIN_ADJUSTED_FONT_WEIGHT, current - IOS_BOLD_TEXT_WEIGHT_REDUCTION);
  return { fontWeight: next as TextStyle['fontWeight'] };
}
